import script from "./SelectIconsColumns.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectIconsColumns.vue?vue&type=script&setup=true&lang=js"

import "./SelectIconsColumns.vue?vue&type=style&index=0&id=7808d6a4&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7808d6a4"]])

export default __exports__